import { useState } from "react";
import { AddIcon, CloseIcon } from "../../kits/Icons/Icons.tsx";
import colorSchema from "../../../assets/kits/colors";

export default function UploadImage({
  //   id,
  type,
  src,
  productImageHandler,
  name,
  shopInfo,
  setShopInfo
}) {
  const [hovering, setHovering] = useState(false);

  return (
    <div className="upload-image-style">
      <div className="cursor-pointer">
        {type == "full" ? (
          <div
            style={{
              position: "relative",
              width: "64px",
              height: "64px",
              borderRadius: "6px",
              backgroundImage: `url('${src}')`,
              backgroundPosition: "center center",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover"
            }}
            onMouseEnter={() => {
              setHovering(true);
            }}
            onMouseLeave={() => {
              setHovering(false);
            }}
          >
            {hovering && (
              <div
                className="d-flex align-items-center justify-content-center"
                style={{
                  backgroundColor: "#111827",
                  opacity: "0.5",
                  width: 64,
                  height: 64,
                  borderRadius: "6px"
                }}
              >
                <div
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setShopInfo(prev => {
                      return { ...prev, [name]: "" };
                    });
                  }}
                >
                  <CloseIcon color="white" />
                </div>
              </div>
            )}
          </div>
        ) : (
          <div>
            <input
              type="file"
              id={name}
              style={{ display: "none" }}
              onChange={e => {
                productImageHandler(name, e.target.files[0]);
              }}
            />
            <label
              htmlFor={name}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                border: `1px dashed ${colorSchema.gray_900}`,
                borderRadius: "6px",
                width: "64px",
                height: "64px",
                //   position: "absolute",
                //   bottom: "-5%",
                //   right: "10px",
                cursor: "pointer",
                padding: "20px"
              }}
            >
              <AddIcon />
            </label>
          </div>
        )}
      </div>
    </div>
  );
}
